/**
 * @export
 * @class Materials
 */
import { MaterialsViewer } from './materials-viewer';

export class Materials {
    public static id = 'materials';


    /**
     * Initialises a new instance of Materials
     */
    constructor() {
        new MaterialsViewer();
    }
}
